import { render, staticRenderFns } from "./EditDebateAdjudicatorsContainer.vue?vue&type=template&id=3da5c6a8&"
import script from "./EditDebateAdjudicatorsContainer.vue?vue&type=script&lang=js&"
export * from "./EditDebateAdjudicatorsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports